
export const Type = {
    setting: "setting",
    main: "main"
}